import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sdCurrency',
})
export class SdCurrencyPipe implements PipeTransform {
  transform(value: any) {
    value = (value || '').toString().replace(/,/g, '');
    if (!value) {
      return null;
    }
    const val = +value;
    if (!Number.isNaN(val)) {
      return val.toLocaleString('en-US');
    }
    return null;
  }
}
